import { render, staticRenderFns } from "./tadiaobiaozhu.vue?vue&type=template&id=99a6133e&scoped=true&"
import script from "./tadiaobiaozhu.vue?vue&type=script&lang=js&"
export * from "./tadiaobiaozhu.vue?vue&type=script&lang=js&"
import style0 from "./tadiaobiaozhu.vue?vue&type=style&index=0&id=99a6133e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "99a6133e",
  null
  
)

export default component.exports